import { useEffect, useState } from "react";
import api from "../lib/api";

const configured = Number(process.env.REACT_APP_STYLE_MATCH_DEFAULT);
export const DEFAULT_STYLE_MATCH = [3, 6, 9].includes(configured) ? configured : 3;

export const useStyleMatch = (userId, sessionReady = true) => {
  const [count, setCount] = useState(DEFAULT_STYLE_MATCH);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => {
    let active = true;
    setCount(DEFAULT_STYLE_MATCH);
    setError("");
    setPending(!!userId);
    if (userId && sessionReady) api.get("/creations/preferences/style-match").then(({ data }) => {
      if (active && [3, 6, 9].includes(data.style_ref_count)) setCount(data.style_ref_count);
    }).catch(() => { if (active) setError("Could not load your saved choice. You can still choose below."); })
      .finally(() => { if (active) setPending(false); });
    return () => { active = false; };
  }, [userId, sessionReady]);

  const choose = async (value) => {
    setCount(value);
    setError("");
    if (!userId) return;
    setPending(true);
    try {
      await api.patch("/creations/preferences/style-match", { style_ref_count: value });
    } catch {
      setError("Choice applies to this duck, but could not be saved for next time.");
    } finally {
      setPending(false);
    }
  };
  return { count, choose, pending, error };
};
